import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/arrow/platform_back.webp";

function Platformarrow() {
  return (
    <section
      className="platform_arrow p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-md-6"
          >
            <h2 style={{ color: "#095237" }}>
              The Platform's Starred Highlighted Features
            </h2>
            <p>
              Arrow Recovery was designed with a single, core purpose of
              facilitating the transactions related to Catalytic Converters.
              This is a very niche industry, there were not a lot of platforms
              previously where such transactions could take place so smoothly.
            </p>
            <p>
              The Arrow Recovery platform provides a smooth and integrated
              platform for users to generate market rates for used and new
              catalytic converters. Users can easily search, buy or sell their
              catalytic converters or know about live rates of platinum,
              palladium and rhodium.
            </p>
            <p>
              But to perform these tasks by facilitating maximum user ease, the
              platform has a wide variety of special features, designed
              specifically to ensure that every aspect of the platform is easy
              to understand:
            </p>
            <ul>
              <li>
                An integrated and comprehensive online catalog of new and used
                catalytic converters
              </li>
              <li>
                Each specific inventory item has a defined serial number of a
                manufacturer query attached to it in order to make user search
                easy
              </li>
              <li>Search by make, model, year or serial number</li>
              <li>
                Complete information related to each inventory item with the
                option to add photos which the user can interact with by swiping
                left or right through a carousel based structure
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformarrow;
